export default "__VITE_ASSET__DB9RVL6r__"